document.addEventListener('DOMContentLoaded', () => {
	Fancybox.bind("[data-fancybox]", {});

	document.querySelectorAll('[data-gallery-opener]').forEach((opener) => {
		opener.addEventListener('click', (e) => {
			e.preventDefault();
			const gallery = opener.dataset.galleryOpener;
			document.querySelector(`[data-fancybox="${gallery}"]`).click();
		});
	});
});